<mat-dialog-content>
	<p>
		{{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
	<button mat-raised-button class="button-white" mat-dialog-close tabindex="-1">{{cancelButtonText}}</button>
    <button mat-raised-button class="custom-delete-btn" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
</mat-dialog-actions>